import { urlBase } from "../../../../Constante/Url";
import axios from "axios";
import { UserTockem } from "../../../../Utils/autenticacao";

function criarConfiguracaoRequisicao(params) {
  return {
    headers: { Authorization: `Bearer ${localStorage.getItem(UserTockem)}` },
    params: params,
  };
}

const listarEstacoes = (page, pageSize, id, params) => {
  let offset = (page - 1) * pageSize;
  const url = `${urlBase}estacao/?cartorio_id=${id}&limit=${pageSize}&offset=${offset}`;
  const config = criarConfiguracaoRequisicao(params);
  const response = axios.get(url, config);
  return response;
};

const atualizarEstacao = async (id, data) => {
  const url = `${urlBase}estacao/${id}/`;
  const config = criarConfiguracaoRequisicao();
  const response = axios.put(url, data, config);
  return response;
};

const deleteEstacao = async (id) => {
  const url = `${urlBase}estacao/${id}/`;
  const config = criarConfiguracaoRequisicao();
  const response = axios.delete(url, config);
  return response;
};

const atualizarBloqueioEstacao = async (data, id) => {
  const url = `${urlBase}estacao/${id}/bloqueio/`;
  const config = criarConfiguracaoRequisicao();
  const response = axios.patch(url, data, config);
  return response;
};
const atualizarAlertaEstacao = async (data, id) => {
  const url = `${urlBase}estacao/${id}/alerta/`;
  const config = criarConfiguracaoRequisicao();
  const response = axios.patch(url, data, config);
  return response;
};
const atualizarServidorEstacao = async (data, id) => {
  const url = `${urlBase}estacao/${id}/servidor/`;
  const config = criarConfiguracaoRequisicao();
  const response = axios.patch(url, data, config);
  return response;
};

const atualizarBloqueioEstacoes = async (id, data) => {
  const url = `${urlBase}cartorio/${id}/estacao-bloqueio/`;
  const config = criarConfiguracaoRequisicao();
  const response = axios.patch(url, data, config);
  return response;
};

const atualizarAlertaEstacoes = async (id, data) => {
  const url = `${urlBase}cartorio/${id}/estacao-alerta/`;
  const config = criarConfiguracaoRequisicao();
  const response = axios.patch(url, data, config);
  return response;
};

export const estacaoRequest = {
  listarEstacoes,
  atualizarEstacao,
  deleteEstacao,
  atualizarBloqueioEstacoes,
  atualizarAlertaEstacao,
  atualizarServidorEstacao,
  atualizarBloqueioEstacao,
  atualizarAlertaEstacoes,
};
